import React from "react";
import styles from './Grid.module.sass';

const Grid = ({
    children,
    axis, position, width, align, gap, padding,
    ...props
}: Props) => {
    return <div className={`
        ${styles['grid']}
        ${styles['grid__axis--'+(axis || 'vertical')]}
        ${styles['grid__position--'+(position || 'inline')]}
        ${styles['grid__align--'+(align || 'none')]}
        ${styles['grid__width--'+(width || 'full')]}
        ${styles['grid__gap--'+(gap || 'medium')]}
        ${styles['grid__padding--'+(padding || 'none')]}
    `}>
        { children }
    </div>;
}

interface Props {
    children?: any
    axis?: 'horizontal' | 'vertical'
    position?: 'centered' | 'inline' | 'between'
    align?: 'start' | 'center'
    width?: 'full' | 'small'
    gap?: 'small' | 'medium' | 'none'
    padding?: 'small' | 'medium' | 'none'
}

export default Grid;